import { FunctionComponent, memo } from 'react';
import { StoryCardAudioContent } from '../../../services';
import { FeedCardAudioCommon, FeedCardContentCommon, FeedCardProps } from '../../../shared';

export const FeedCardAdminAudio: FunctionComponent<FeedCardProps> = memo(({ card, chatId }) => {
  const {
    storyId,
    id,
    type,
    content,
    isPinnedToTopOfNewsFeed,
    isPinnedToTopOfStory,
    mentionedUsers,
  } = card;

  const { sourceName, headline, subHeadline, text, textHTML } = content as StoryCardAudioContent;

  return (
    <FeedCardContentCommon
      type={type}
      isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
      isPinnedToTopOfStory={isPinnedToTopOfStory}
      storyId={storyId}
      cardId={id}
      source={sourceName}
      title={headline}
      media={<FeedCardAudioCommon card={card} chatId={chatId} />}
      subTitle={subHeadline}
      text={text}
      htmlText={textHTML}
      mentionedUsers={mentionedUsers}
    />
  );
});
